// import hooks
import { useQuery } from 'react-query';

// import queries & mutations
import { getEmployeeNotes } from 'RestAPIs/employees/notes';

// import types
import type { EmployeeNotesResponse } from 'RestAPIs/employees/notes';
import type { UseQueryOptions } from 'react-query';
import type { UseGetEmployeeNotesProps } from './useGetEmployeeNotes.types';

const useGetEmployeeNotes = (
  { employeeId }: UseGetEmployeeNotesProps,
  options: UseQueryOptions<EmployeeNotesResponse[]> = {}
) => {
  const {
    data = [],
    isFetching,
    isError,
    refetch
  } = useQuery<EmployeeNotesResponse[]>(
    ['employeeNotes', 'list', employeeId],
    () => getEmployeeNotes({ employeeId }).then((response) => response.data),
    {
      ...options
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeNotes;
